// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"c2-z","colorTextValue":"d2-z","swatches":"e2-z","collapseLink":"f2-z","isCollapsed":"g2-z","dropdown":"h2-z","disabled":"i2-z"};